import classes from '@/components/Fieldset/Fieldset.module.scss';
import classNames from 'classnames';
import type { ReactNode } from 'react';

type FieldsetProps = {
  title?: string;
  children?: ReactNode;
  className?: string;
};

const Fieldset: React.FC<FieldsetProps> = ({ children = null, title = null, className = '' }) => {
  return (
    <fieldset className={classNames(classes.fieldset, className)}>
      {title && <legend className={classes.legend}>{title}</legend>}
      {children && <div className="formGrid">{children}</div>}
    </fieldset>
  );
};

export default Fieldset;
